export enum PlaylistEvents {
  TrackEnded = "track.ended",

  ChangeTrack = "track.changed",

  PlaylistEmpty = "playlist.empty",

  Play = "playlist.play",

  Pause = "playlist.pause",

  Started = "playlist.started",

  Stopped = "playlist.stopped",

  Ended = "playlist.ended",
}
